/* unplugin-vue-components disabled */import script from "./OrderDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetailModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderDetailModal.vue?vue&type=style&index=0&id=5917458c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5917458c"]])

export default __exports__